module.exports = __webpack_public_path__ + "img/pro-p-slider4.80db507d.png";